<template>
    <transition-group name="slide-in" tag="ul" class="alerts" @click="clickHandle">
        <cph-alert v-for="(alert, index) in alerts"
                   :alert="alert"
                   @click="clickHandle"
                   :key="'alert-' + alert.id" v-show="index < 5">
        </cph-alert>
    </transition-group>
</template>

<script type="text/babel">
import CphAlert from './CphAlert';
export default {
    name: 'CphAlertList',
    props: {
        alerts: {
            type: Array,
            required: true
        }
    },
    components: {
        CphAlert
    },
    methods: {
        clickHandle(){
            console.log("clickHandle")
        }
    }
};

</script>

<style lang="scss" scoped>
    .alerts {
        position: fixed;
        z-index: 3000;
        top: 4em;
        right: 2em;
        list-style-type: none;
    }
</style>
